import React from 'react';
import bitmapBackground from 'assets/images/bitmap-background.png';
import MainLayout from 'components/layout/MainLayout';
import BookShelf from './components/BookShelf';
import makeStyles from '@mui/styles/makeStyles';
import { BookType } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { ButtonTypes } from 'types';

const LetterBooks: React.FC = () => {
  const classes = styles();

  return (
    <MainLayout
      scrollY={true}
      backgroundImg={bitmapBackground}
      menuProps={{
        primaryLeftButton: { name: ButtonTypes.HOME_BUTTON },
      }}
      footerProps={{
        className: classes.footer,
        primaryRightButton: { name: ButtonTypes.ACCESSIBILITY_BUTTON },
      }}
    >
      <BookShelf bookType={BookType.LETTER_BOOK} />
    </MainLayout>
  );
};

export default LetterBooks;

const styles = makeStyles(() => ({
  footer: {
    background: 'linear-gradient(180deg, rgba(206,234,255,0) 0%, #F7EAD9 100%)',
    bottom: '0px',
  },
}));
